import React, { useState } from "react";
import garden from "../assets/garden.jpg";
import frontview from "../assets/frontview.jpg";
import sideview from "../assets/sideview.jpg";
import "../style/imagegalley.css";

const ImageGallery1 = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const images = [
    { thumb: frontview, full: frontview, title: "Front View" },
    { thumb: garden, full: garden, title: "Garden" },
    { thumb: sideview, full: sideview, title: "Side View" },
  ];

  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="gallery-item">
            <img src={img.thumb} alt={`Thumbnail ${index}`} loading="lazy" />
            <h4>{img.title}</h4>
            <button onClick={() => setSelectedImage(img.full)}>View</button>
          </div>
        ))}
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="modal-overlay"
          onClick={() => setSelectedImage(null)} // close when clicking outside
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={selectedImage} alt="Full View" loading="lazy" />
            <button
              className="close-btn"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageGallery1;
